/**
 * WebRTC ICE 서버 목록 — 원격지원(remoteSupportService)용.
 *
 * callService.ts의 getIceServers와 같은 값이다(구글 STUN 2개 + 빌드 env TURN). 원격지원 설계상 통화 코드는
 * 고치지 않으므로(docs/remote-support-2026-10.md §4.7) 그쪽 함수를 export로 바꾸지 않고 여기 둔다.
 * 사내 TURN(Phase 2)을 붙일 때는 이 파일과 callService 양쪽에 같은 캐시를 더한다.
 */
export function getIceServers(): RTCIceServer[] {
  const servers: RTCIceServer[] = [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
  ];
  const turnUrl = process.env.REACT_APP_TURN_SERVER_URL;
  const turnUser = process.env.REACT_APP_TURN_USERNAME;
  const turnCred = process.env.REACT_APP_TURN_CREDENTIAL;
  if (turnUrl && turnUser && turnCred) {
    servers.push({ urls: turnUrl, username: turnUser, credential: turnCred });
  }
  return servers;
}
